"use client";

// The root error boundary. It sits INSIDE the root layout, so the ground, the
// fonts, the theme and the boot veil all stay: a route that throws becomes one
// calm page in the house language instead of falling through to global-error
// (which has to rebuild the whole document by hand). It retries quietly while
// the tab is visible, and every segment below has its own thin copy of this.

import { RouteError } from "../components/brand/NettiError";

export default function RootError(props: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  return <RouteError {...props} where="root" />;
}
